import { render, staticRenderFns } from "./Third.vue?vue&type=template&id=0013dbe6&"
import script from "./Third.vue?vue&type=script&lang=js&"
export * from "./Third.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports